var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
var UrlParamsContext = createContext(null);
export function UrlParamsProvider(_a) {
    var children = _a.children;
    var _b = useSearchParams(), searchParams = _b[0], setSearchParams = _b[1];
    var navigate = useNavigate();
    var getParam = function (key) {
        return searchParams.get(key);
    };
    var setParam = function (key, value, options) {
        var newSearchParams = new URLSearchParams(searchParams.toString());
        if (value === null || value === undefined) {
            newSearchParams.delete(key);
        }
        else {
            newSearchParams.set(key, value);
        }
        var method = (options === null || options === void 0 ? void 0 : options.replace) ? 'replace' : 'push';
        navigate({ search: newSearchParams.toString() }, { replace: method === 'replace' });
    };
    // useEffect(() => {
    // 	// Update the searchParams state whenever the URL changes
    // 	setSearchParams(new URLSearchParams(window.location.search));
    // 	// eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [window.location.search]);
    return (_jsx(UrlParamsContext.Provider, __assign({ value: { getParam: getParam, setParam: setParam, params: searchParams } }, { children: children })));
}
export function useUrlParams() {
    var context = useContext(UrlParamsContext);
    if (context === null) {
        throw new Error('useUrlParams must be used within a UrlParamsProvider');
    }
    return context;
}
